<template>
  <span class="risk-score-tag" :class="'risk-level-' + level">
    <span class="score-num">{{ score }}</span>
    <span v-if="showLabel" class="score-label">{{ label }}</span>
  </span>
</template>

<script>
export default {
  name: 'RiskScoreTag',
  props: {
    score: { type: Number, required: true },
    thresholds: {
      type: Object,
      default: () => ({ lowMax: 4, mediumMax: 10 })
    },
    showLabel: { type: Boolean, default: true }
  },
  computed: {
    level() {
      if (this.score > this.thresholds.mediumMax) return 3
      if (this.score > this.thresholds.lowMax) return 2
      return 1
    },
    label() {
      const map = { 1: '低', 2: '中', 3: '高' }
      return map[this.level] || ''
    }
  }
}
</script>

<style scoped>
.risk-score-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 10px;
  border-radius: var(--radius-full);
  font-size: 13px;
  font-weight: 600;
}
.risk-level-1 {
  background: var(--color-low-bg);
  color: var(--color-low-text);
}
.risk-level-2 {
  background: var(--color-medium-bg);
  color: var(--color-medium-text);
}
.risk-level-3 {
  background: var(--color-high-bg);
  color: var(--color-high-text);
}
.score-num {
  font-weight: 700;
}
.score-label {
  font-size: 12px;
  opacity: 0.85;
}
</style>
